import { CurrencyType } from '../web3';

import BigBet from 'assets/png/boxes/full-box.png?format=webp;avif&as=picture';
import BigMobileBet from 'assets/png/boxes/full.png?format=webp;avif&as=picture';
import MediumBet from 'assets/png/boxes/middle-box.png?format=webp;avif&as=picture';
import MediumMobileBet from 'assets/png/boxes/middle.png?format=webp;avif&as=picture';
import SmallBet from 'assets/png/boxes/small-box.png?format=webp;avif&as=picture';
import SmallMobileBet from 'assets/png/boxes/small.png?format=webp;avif&as=picture';

const imageMap = {
  desktop: {
    small: SmallBet,
    medium: MediumBet,
    big: BigBet,
  },
  mobile: {
    small: SmallMobileBet,
    medium: MediumMobileBet,
    big: BigMobileBet,
  },
} as const;

export const getPrizeImage = (
  bet: number,
  selectedCurrency?: CurrencyType,
  isMobile: boolean = false,
) => {
  const [small, medium, big] = selectedCurrency?.bet ?? ['0', '0', '0'];
  const view = isMobile ? 'mobile' : 'desktop';

  if (+bet >= Number(big)) return imageMap[view].big;
  if (+bet >= Number(medium)) return imageMap[view].medium;
  return imageMap[view].small;
};
